import { get, post, patch } from 'utils/api';

export const getMuralArts = () => get('/muralArts');

export const getMuralArtStations = () => get('/muralArts/stations');

export const getMuralArtOptions = () => get('/muralArts/options');

export const createMuralArt = (data) => post('/muralArts', data);

export const updateMuralArt = (id, data) => patch(`/muralArts/${id}`, data);
